import { Button, Typography, ButtonProps } from 'taxaroo-ui';

const { Title, Paragraph } = Typography;

interface ButtonWithTextProps {
  onPress: () => void;
  title: string;
  description: string;
  buttonText: string;
  buttonProps: ButtonProps;
}
const ButtonWithText = ({
  onPress, title, description, buttonText, buttonProps,
}: ButtonWithTextProps) => (
  <>
    <Title level={3}>
      {title}
    </Title>
    <Paragraph style={{ marginTop: -15 }}>
      {description}
    </Paragraph>
    <Button
      type="primary"
      style={{ width: '300px' }}
      size="large"
      onClick={onPress}
      {...buttonProps}
    >
      {buttonText}
    </Button>
  </>
);

export default ButtonWithText;
